import { createFileRoute } from "@tanstack/react-router";

import { PeoplePage } from "../../../workspaces/production/pages/PeoplePage";

/* People: who is on the floor now, whether they are working, and on what. */
export const Route = createFileRoute("/_console/production/people")({
  component: PeoplePage,
});
